import AngleLeftIcon from "@svg/angle-left";
import Image from "next/image";
import { useRouter } from "next/router";

const ExploreEmptyState = () => {
  const { back } = useRouter();
  return (
    <div className="flex flex-col items-center justify-center mt-12 sm:mt-52">
      <div className="mb-6">
        <Image
          src="https://faradars.org/wp-content/uploads/2024/06/01/explore-empty-state.svg"
          alt="explore-empty-state"
          width={221}
          height={220}
        />
      </div>
      <span className="mb-2 text-lg font-semibold leading-7 text-[#3F3F46]">
        نتیجه‌ای با این مشخصات یافت نشد.
      </span>
      <span className="text-fds-secondary  text-sm font-normal leading-7 items-center flex">
        لطفا فیلترها را تغییر دهید تا به نتیجه دلخواه برسید
        <AngleLeftIcon
          onClick={() => back()}
          className="mr-1 h-5 w-5 hover:text-fds-brand cursor-pointer"
          xlinkTitle="بازگشت به صفحه قبل"
        />
      </span>
    </div>
  );
};

export default ExploreEmptyState;
